import { ImageArrow } from "components/utility/images";
import React, { useEffect, useState, useRef } from "react";

const MediaCenterFacet = (props) => {
	const { facet, field } = props;
	const [facetState, setState] = useState(facet.state);
	const [facetArr, setFacetArr] = useState([]);
	const [toggle, setToggle] = useState(false);
	const ref = useRef(null);
	useEffect(() => {
		facet.subscribe(() => {
			setState(facet.state);
		});
	}, [facet]);

	useEffect(() => {
		if (facetState.values.length > 0) {
			let arr = [...facetState.values];
			setFacetArr(
				arr.sort((a, b) => {
					return b.value - a.value;
				})
			);
		}
	}, [facetState.values]);

	useEffect(() => {
		const handleScroll = () => setToggle(false);
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [setToggle]);

	return (
		<>
			<div className="newsroom-bar-facet">
				<button
					className={"newsroom-bar-facet-button " + (toggle === true ? "selected" : "")}
					onClick={() => setToggle(!toggle)}
					data-tag={field[0].name}
					aria-expanded={toggle}
				>
					{field[0].name}
					<ImageArrow />
				</button>
			</div>
			<div className={"newsroom-bar-sublists " + (toggle === true ? "show" : "hide")} ref={ref}>
				{facetArr.map((value) => {
					return (
						<div key={value.value} className="newsroom-bar-sublist">
							<button
								className={
									"newsroom-bar-sublist-button" + (value.state === "selected" ? " selected" : "")
								}
								onClick={() => {
									facet.toggleSelect(value);
								}}
								aria-label={value.value}
								data-a="true"
								data-a-lbl={value.value}
								data-a-cat="Coveo"
								data-a-act={`Filter | ${field[0].name}`}
							>
								{value.value}
							</button>
						</div>
					);
				})}
			</div>
		</>
	);
};

export default MediaCenterFacet;
